// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__GkOY2","colBig":"styles_colBig__1jaYF","colSmall":"styles_colSmall__sbw_G"};